import { useCallback } from 'react';
import useSWR from 'swr';

import { AgentApiRequestHelper } from '../agent-api-request-helper';
import { DOCUMENT_READER_FINISHED_RUN_STATES } from './constants';
import type {
  IDocumentReaderRunResponse,
  IUseDocumentReaderRunResult,
} from './types';

export function useDocumentReaderRun(
  runId: string | null
): IUseDocumentReaderRunResult {
  const { data, isLoading, error, mutate } = useSWR(
    runId
      ? `agent-platform/document-reader/runs/${encodeURIComponent(runId)}`
      : null,
    (path: string) =>
      AgentApiRequestHelper.read<IDocumentReaderRunResponse>(path),
    {
      // A run that has ended never changes again, so asking stops there.
      refreshInterval: (latest?: IDocumentReaderRunResponse) =>
        latest && DOCUMENT_READER_FINISHED_RUN_STATES.includes(latest.run.state)
          ? 0
          : 5000,
      revalidateOnFocus: false,
    }
  );

  const refreshRun = useCallback(async () => {
    await mutate();
  }, [mutate]);

  return { run: data?.run ?? null, isLoading, error, refreshRun };
}
